import { Header, Icon, Segment } from 'semantic-ui-react';

function BranchDiffLegend() {
    return (
        <Segment className="branch-comparison-details">
            <Header as="h5" dividing>
                Legend
            </Header>
            <table
                aria-label="Branch difference legend"
                className="branch-comparison-details__table branch-comparison-details__table--reports"
            >
                <tbody>
                    <tr>
                        <th scope="row" className="branch-comparison-details__cell--added">
                            Added
                        </th>
                        <td>Present in the your(target) branch, absent from the peer(reference) branch.</td>
                    </tr>
                    <tr>
                        <th scope="row" className="branch-comparison-details__cell--removed">
                            Removed
                        </th>
                        <td>Present in the peer(reference) branch, absent from your (target) branch.</td>
                    </tr>
                    <tr>
                        <th scope="row" className="branch-comparison-details__cell--model-changed">
                            Model field difference
                        </th>
                        <td>A field has different model properties. Click it to see available details.</td>
                    </tr>
                    <tr>
                        <th scope="row" className="branch-comparison-details__cell--value-difference">
                            Core value difference
                        </th>
                        <td>A report field's core value differs between branches.</td>
                    </tr>
                    <tr>
                        <th scope="row" className="branch-comparison-details__cell--calculated-value-difference">
                            Manually calculated core value difference
                        </th>
                        <td>Both branches mark the field manually calculated, and its core value differs.</td>
                    </tr>
                    <tr>
                        <th scope="row" className="branch-comparison-details__cell--other-difference">
                            Non core value difference
                        </th>
                        <td>A report field property other than the core value differs.</td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <Icon name="info" color="blue" /> Source available
                        </th>
                        <td>Source view has provenance for this value. In Edit/Review, click to open Review provenance when available.</td>
                    </tr>
                </tbody>
            </table>
        </Segment>
    );
}

export default BranchDiffLegend;
